import { useCallback } from "react";

import { useInvalidateQueries } from "./invalidateQueries.utils";

/** @description when user marks any type of lady dto as favorite */
export const useInvalidateLadyFavorite = () => {
  const { invalidateQueries } = useInvalidateQueries();

  const invalidate = useCallback(() => {
    invalidateQueries([
      "LADIES_LIST_FAVORITE",
      "NEWSFEED_LIST",
      "LADY_PROFILE",
      "LADIES_SEARCH",
      "LADY_PROFILE_SUGGESTED_LADIES",
    ]);
  }, [invalidateQueries]);

  return { invalidate };
};
